<template>
  <section class="products">
    <div class="products-container">
      <h1 class="title">
        <span>our products</span>
        <a class="text-decoration-none" href=""> view all >></a>
      </h1>
      <div class="box-container">
        <div v-for="product in products" :key="product.id" class="box">
          <div class="icons">
            <router-link to="">
              <font-awesome-icon icon="shopping-cart" />
            </router-link>
            <router-link to="">
              <font-awesome-icon icon="heart" />
            </router-link>
            <router-link to="">
              <font-awesome-icon icon="eye" />
            </router-link>
          </div>
          <div class="image">
            <img :src="product.image" alt="" />
          </div>
          <div class="content">
            <div class="price">{{ product.price }}</div>
            <h3>{{ product.name }}</h3>
            <div class="stars">
              <font-awesome-icon class="icon" icon="star" />
              <font-awesome-icon class="icon" icon="star" />
              <font-awesome-icon class="icon" icon="star" />
              <font-awesome-icon class="icon" icon="star" />
              <font-awesome-icon
                class="icon"
                :icon="{ prefix: 'far', iconName: 'star' }"
              />
              <span> ({{ product.comment }}) </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
const dummyData = {
  products: [
    {
      id: "1",
      name: "morden furniture",
      image: require("@/images/product-1.jpg"),
      price: "$140.00",
      comment: 50,
    },
    {
      id: "2",
      name: "morden furniture",
      image: require("@/images/product-2.jpg"),
      price: "$140.00",
      comment: 48,
    },
    {
      id: "3",
      name: "morden furniture",
      image: require("@/images/product-3.jpg"),
      price: "$140.00",
      comment: 30,
    },
    {
      id: "4",
      name: "morden furniture",
      image: require("@/images/product-4.jpg"),
      price: "$140.00",
      comment: 80,
    },
    {
      id: "5",
      name: "morden furniture",
      image: require("@/images/product-5.jpg"),
      price: "$140.00",
      comment: 63,
    },
    {
      id: "6",
      name: "morden furniture",
      image: require("@/images/product-6.jpg"),
      price: "$140.00",
      comment: 90,
    },
    {
      id: "7",
      name: "morden furniture",
      image: require("@/images/product-7.jpg"),
      price: "$140.00",
      comment: 12,
    },
    {
      id: "8",
      name: "morden furniture",
      image: require("@/images/product-8.jpg"),
      price: "$140.00",
      comment: 83,
    },
  ],
};

export default {
  data() {
    return {
      products: [],
    };
  },
  created() {
    this.fetchProducts();
  },
  methods: {
    fetchProducts() {
      this.products = dummyData.products;
    },
  },
};
</script>